import React, { useEffect } from "react";
import Loader from "@components/common/Loader";
import DashboardLayout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import { getValue } from "@utils/lodash";
import { config } from "../../../../env";
import { toast } from "react-toastify";
import { getAllPermissionsWithToken } from "@services/roles.service";
import _ from "lodash";
import { allNavigationMenu } from "@components/common/LeftNavbar/PermissionJSON";

let port = window.location.origin.split("//")[1].split(":")[0];
function AuthRefresh(props: any) {
  useEffect(() => {
    handleRefresh();
  }, []);

  const logout = () => {
    localStorage.clear();
  };

  const handleRefresh = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          source:
            port === "localhost"
              ?config.SOURCE
              : window.location.origin?.split("//")[1],
        },
        body: JSON.stringify({
          refresh_token: getValue(localStorage, `refreshToken`, ""),
        }),
      };
      
      return fetch(`${config.API_URL}/auth/user/refresh`, requestOptions).then(
        (data) => {
          data.text().then(async (text) => {
            if (!data.ok) {
              if (data.status === 401 || data.status === 429) {
                toast.error("Unauthorized");
                logout();
                window.location.href = `/login`;
              }
            } else {
              let resp = JSON.parse(text);
              let getPermissions = await getAllPermissionsWithToken(
                getValue(resp, `data.accessToken`, "")
              );
              let response = getValue(
                getPermissions,
                `data.permissions`,
                []
              ).filter((item: any) => {
                if (item) return item;
              });
              let subTabPermissions = handlePermissionLogic(response);
              let link = optimizeNavigationMenus(
                getValue(subTabPermissions, `tabs`, []),
                getValue(subTabPermissions, `subTabs`, [])
              );
              localStorage.setItem(
                "accessToken",
                getValue(resp, `data.accessToken`, "")
              );
              localStorage.setItem(
                "refreshToken",
                getValue(resp, `data.refreshToken`, "")
              );
              localStorage.setItem(
                "user",
                JSON.stringify(getValue(resp, `data.user`, ""))
              );
              window.location.href = `${link}`;
            }
          });
        }
      );
    } catch (error) {}
  };
  const covertSecondString = (s: string) => {
    var lastIndex = s.lastIndexOf(":");
    if (lastIndex !== -1) {
      s = s.substring(0, lastIndex) + "-" + s.substring(lastIndex + 1);
    }
    return s;
  };
  const handlePermissionLogic = (response: any) => {
    let list =
      getValue(response, `length`, 0) > 0
        ? response.map((item: any) => {
            return covertSecondString(item).split("-").length === 2
              ? covertSecondString(item).split("-")
              : item.split(":");
          })
        : [];

    let arr: any = [];
    for (let i = 0; i < list.length; i++) {
      arr.push({
        tab: list[i][0],
        permission: list[i][1],
      });
    }
    var groupedPermission =
      getValue(arr, `length`, 0) > 0
        ? _.groupBy(arr, function (item: any) {
            return item.tab;
          })
        : [];
    var ObjectEntry: any = Object.entries(groupedPermission);
    const arr1: any = [];
    for (let i = 0; i < ObjectEntry.length; i++) {
      arr1.push({
        tab: ObjectEntry[i][0].split(":")[0],
        tabKey:
          ObjectEntry[i][0].split(":").length == 2
            ? ObjectEntry[i][0].split(":")[0] +
              "_" +
              ObjectEntry[i][0].split(":")[1]
            : ObjectEntry[i][0].split(":").length == 3
            ? ObjectEntry[i][0].split(":")[0] +
              "_" +
              ObjectEntry[i][0].split(":")[1] +
              "_" +
              ObjectEntry[i][0].split(":")[2]
            : ObjectEntry[i][0].split(":")[0],
        permissions: ObjectEntry[i][1].map((item: any) => item.permission),
      });
    }
    let tabs = _.uniq(arr1.map((item: any) => item.tab));
    let subTabs = _.uniq(arr1.map((item: any) => item.tabKey));
    return { tabs, subTabs };
  };

  function optimizeNavigationMenus(
    permissions: string[],
    subTabPermissionList: string[]
  ): any {
    let mainMenu: any =
      getValue(allNavigationMenu, `length`, 0) > 0 &&
      allNavigationMenu.filter((item: any) =>
        permissions.includes(getValue(item, `name`, ""))
      );
    let checkChildrensPermission =
      getValue(mainMenu, `length`, 0) > 0 &&
      mainMenu.map((menuItem: object) => {
        let menus =
          getValue(menuItem, `menu.length`, 0) > 0 &&
          getValue(menuItem, `menu`, []).map((item: object) => {
            let childrens =
              getValue(item, `childrens.length`, 0) > 0 &&
              getValue(item, `childrens`, []).filter((child: object) =>
                subTabPermissionList.includes(getValue(child, `name`, ""))
              );
            if (getValue(item, `childrens.length`, 0) > 0) {
              return {
                ...item,
                childLink: getValue(childrens, `[${0}].link`, ""),
                name: getValue(childrens, `[${0}].name`, ""),
                childrens: childrens,
              };
            } else {
              return {
                ...item,
                childLink: getValue(item, `link`, ""),
              };
            }
          });
        return {
          ...menuItem,
          menu: menus,
        };
      });

    let checkMenuPermission =
      getValue(checkChildrensPermission, `length`, 0) > 0 &&
      checkChildrensPermission.map((menuItem: object) => {
        let menus =
          getValue(menuItem, `menu.length`, 0) > 0
            ? getValue(menuItem, `menu`, []).filter((item: object) =>
                subTabPermissionList.includes(getValue(item, `name`, ""))
              )
            : [];

        return {
          ...menuItem,
          menu: menus,
        };
      });
    return getValue(checkMenuPermission, `[${0}].menu[${0}].childLink`, "");
    // return getValue(checkMenuPermission, `length`, 0) > 0
    //   ? checkMenuPermission.map((item: object) => ({
    //       ...item,
    //       childLink: getValue(item, `menu[${0}].childLink`, ""),
    //     }))
    //   : [];
  }
  return (
    <DashboardLayout>
      <Loader />
    </DashboardLayout>
  );
}

export default AuthRefresh;
